import React from "react";
import {
    Button, Flex, Icon, Modal, ModalBody, ModalCloseButton, ModalContent,
    ModalFooter, ModalHeader, ModalOverlay, Text, useColorModeValue,
} from "@chakra-ui/react";
import { MdWarningAmber } from "react-icons/md";

/**
 * Confirmation dialog shown before regenerating all QR codes.
 * Warns the user about the heavy operation and provides confirm/cancel actions.
 *
 * @param {object} props
 * @param {boolean} props.open - Whether the dialog is currently visible.
 * @param {Function} props.onClose - Callback to close the dialog without confirming.
 * @param {Function} props.onConfirm - Callback invoked when the user confirms the action.
 * @returns {React.ReactElement} The confirmation dialog element.
 */
function RegenerateConfirmDialog({ open, onClose, onConfirm }) {
    const subColor = useColorModeValue("secondaryGray.600", "secondaryGray.400");
    return (
        <Modal isOpen={open} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>
                    <Flex align="center" gap="8px">
                        <Icon as={MdWarningAmber} color="orange.500" w="22px" h="22px" />
                        <Text>Confirmation</Text>
                    </Flex>
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Text fontSize="sm" mb="6px">
                        This will regenerate the QR codes of every service. This may take several minutes.
                    </Text>
                    <Text fontSize="xs" color={subColor}>
                        Connected users will receive real-time updates via socket.
                    </Text>
                </ModalBody>
                <ModalFooter gap="8px">
                    <Button variant="ghost" onClick={onClose}>Cancel</Button>
                    <Button colorScheme="orange" onClick={onConfirm}>Confirm Regeneration</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}

export default RegenerateConfirmDialog;
